import { render, staticRenderFns } from "./LockedProducts.vue?vue&type=template&id=62c67776"
import script from "./LockedProducts.vue?vue&type=script&lang=js"
export * from "./LockedProducts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports